import { connect } from "react-redux";
import { withRouter } from "next/router";
import { withTranslation } from "../../../../i18n";

import Base from "./Base";

const mapStateToProps = ({ global, breadCrumbs }) => ({
  global,
  breadCrumbs
});

export default withTranslation(["common"])(
  withRouter(connect(mapStateToProps)(Base))
);
